/**
 * Acciones para la creación de usuario en la gestión de usuarios para el rol supervisor
 * gu_cu_ = Gestión de Usuario (gu) _ Creación de Usuario (cu)
 */
import {Dispatch} from 'react'
import * as http from '../../../api/http'
import {ENDPOINTS} from '../../../api/config'
import {State} from '../../../reducers'
import {generalOpenModalError, generalOpenModalInfo, generalShowLoader} from '../../general.actions'
import {GESTION_USUARIO_TYPES} from '../../../constants/gestionUsuario.types'
import {GestionUsuarioAction} from '../../../interfaces/gestion-usuarios.interace'
import {
  validacionesCodigoHandleChangeFacturador,
  validacionesCodigoOnBlurFacturador,
  validacionesHandleChangeFacturador,
  validacionesOnBlurFacturador,
} from '../gu-generales/gu-generales'
import {KEYS} from '../../../constants/keysStorage'
import {ROL_POR_OMISION, resolverRolID} from '../../../constants/roles'
import jsPDF from 'jspdf'
import autoTable, {UserOptions} from 'jspdf-autotable'
import {DICCIONARIO} from '../../../constants/Diccionario'

import logoFeles from '../../../media/logos/PNG/ISO_FELES_Supervisor.png'
import { pdfPerfilTableAcceso, pdfPerfilTableDocumentos, pdfPerfilTableEmisor, pdfPerfilTableSucursales, pdfPerfilTableUsuario, pdfPerfilAddFooters, pdfPerfilAddHeaders } from '../../../utils/pdfPerfil'

// ******************************************************************************************
export const gu_cu_HandleChange = (formUser: any) => ({
  type: GESTION_USUARIO_TYPES.CU_FORM_HANDLE_CHANGE,
  payload: formUser,
})

export const gu_cu_VerifyCodeHandleChange = (form: any) => ({
  type: GESTION_USUARIO_TYPES.CU_FORM_VERIFY_CODE_HANDLE_CHANGE,
  payload: form,
})

export const gu_cu_ChangePage = (num: number) => ({
  type: GESTION_USUARIO_TYPES.CU_FORM_CHANGE_PAGE,
  payload: num,
})

export const gu_cu_Clear = () => ({
  type: GESTION_USUARIO_TYPES.CU_FORM_CLEAR,
  payload: null,
})

export const gu_cu_creacionUsuarioFormAddError = (error: any) => ({
  type: GESTION_USUARIO_TYPES.CU_FORM_ADD_ERROR,
  payload: error,
})

export const gu_cu_creacionUsuarioFormAddErrorCode = (error: any) => ({
  type: GESTION_USUARIO_TYPES.CU_FORM_ADD_ERROR_VERIFY_CODE,
  payload: error,
})

export const gu_cu_ShowModalConfirmacion = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.CU_SHOW_MODAL_CONFIRMACION,
  payload: flag,
})

export const gu_cu_ShowModalVerificacion = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.CU_SHOW_MODAL_VERIFICACION,
  payload: flag,
})

export const gu_cu_ShowModalConfirmar = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.CU_SHOW_MODAL_CONFIRMAR,
  payload: flag,
})

export const gu_cu_ShowModalCreado = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.CU_SHOW_MODAL_CREADO,
  payload: flag,
})

export const gu_cu_SetSucursales = (sucursales: any) => ({
  type: GESTION_USUARIO_TYPES.CU_SET_SUCURSALES,
  payload: sucursales,
})

export const gu_cu_SetSucursalesSeleccionadas = (sucursales: Array<string>) => ({
  type: GESTION_USUARIO_TYPES.CU_SET_SUCURSALES_ASIGNADAS,
  payload: sucursales,
})

export const gu_cu_SetIdUsuarioCreado = (id: any) => ({
  type: GESTION_USUARIO_TYPES.CU_SET_ID_USUARIO_CREADO,
  payload: id,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const gu_cu_FormHandleChangePhone =
  (phone: string) => async (dispatch: Dispatch<GestionUsuarioAction>) => {
    if (!validacionesHandleChangeFacturador('phone_number', phone)) return
    dispatch(gu_cu_HandleChange({phone_number: phone}))
  }
export const gu_cu_FormHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {name, value} = e.target

    if (!validacionesHandleChangeFacturador(name, value)) return
      dispatch(gu_cu_HandleChange({[name]: String(value).toLowerCase()}))

    if(name === 'username')
      dispatch(gu_cu_HandleChange({[name]: String(value).toLowerCase()}))
    else if(name === 'id_number'){
      switch (getState().gestionUsuario.creacionUsuario.formUser.nombreTipoDocumento?.toLowerCase()) {
        case 'dui':
          value = value.substring(0, 9);
          value = String(value).replace(/[^0-9\s\-]/g, "")
            break;
        case 'nit':
          value = String(value).replace(/[^0-9\s\-]/g, "")
            break;
        default:
          value = value.toUpperCase()
            break;
      }

      dispatch(gu_cu_HandleChange({[name]: value}))
    } else
      dispatch(gu_cu_HandleChange({[name]: value}))

    if (name === 'tipoDocumento') {
      const tipoDoc = getState().catalogos.tipoDocumento.find((doc) => value === doc.codigo)
      dispatch(gu_cu_HandleChange({id_number: ''}))
      dispatch(gu_cu_creacionUsuarioFormAddError({id_number: ''}))

      if (tipoDoc) 
        dispatch(gu_cu_HandleChange({nombreTipoDocumento: tipoDoc.valor}))
      else 
        dispatch(gu_cu_HandleChange({nombreTipoDocumento: ''}))
    }
  }

export const gu_cu_FormVerifyCodeHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<GestionUsuarioAction>) => {
    let {name, value} = e.target
    if (!validacionesCodigoHandleChangeFacturador(name, value)) return
    dispatch(gu_cu_VerifyCodeHandleChange({[name]: value}))
  }

export const generatePDFInfo =
  (metodo = "supervisor") => async (dispatch: Dispatch<any>, getState: () => State) => {
    try {
      const {formUser, sucursalesAsignadas, datosUsuarioCreado} =
        getState().gestionUsuario.creacionUsuario
      const {sucursales} = getState().gestionUsuario.creacionUsuario.catalogos
      const {datosEmisor: formClient, tipoDocumentosEmision, tipoEstablecimientos} = getState().catalogos
      const pdf = new jsPDF()

      const tipoEstablecimiento = tipoEstablecimientos.find((tipo) => tipo.codigo === formClient.tipoestablecimiento);
      const bodyTableSucursales = sucursalesAsignadas
        .map((element) => {
          const sucursal = sucursales.find((el: any) => el.idsucursal === element);
          return sucursal ? [sucursal.nombre, sucursal.direccion] : null;
        })
        .filter(Boolean);

      const bodyTableDocumentos = sucursalesAsignadas.reduce((acc, element) => {
        const sucursal = sucursales.find(el => el.idsucursal === element);
        if (!sucursal || !sucursal.Documento || !Array.isArray(sucursal.Documento)) return acc;
        
        const documentos = sucursal.Documento
            .filter((doc:any) => doc.estado === "true")
            .map((doc:any) => [
                sucursal.nombre,
                tipoDocumentosEmision.find(docuEmision => ""+docuEmision.iddocumento === doc.iddocumento)?.nombre,
                doc.serie,
            ]);
        
        return acc.concat(documentos);
      }, [] as Array<Array<string>>);

      const tablaDatosDeUsuario = pdfPerfilTableUsuario(formUser);
      const tablaDatosDeEmisor = pdfPerfilTableEmisor({...formClient, desTipoEstablecimiento: tipoEstablecimiento?.valor});
      const tablaSucursales = pdfPerfilTableSucursales(bodyTableSucursales);
      const tablaDocumentos = pdfPerfilTableDocumentos(bodyTableDocumentos);
      const tablaAcceso = pdfPerfilTableAcceso(formUser, datosUsuarioCreado);

      // AGREGAR HEADER
      pdfPerfilAddHeaders(pdf, formClient, formUser);
      // AGREGAR TABLAS
      autoTable(pdf, tablaDatosDeUsuario)
      autoTable(pdf, tablaDatosDeEmisor)
      if (metodo === "supervisor") { autoTable(pdf, tablaAcceso) }
      autoTable(pdf, tablaSucursales)
      autoTable(pdf, tablaDocumentos)
      // AGREGAR FOOTER
      pdfPerfilAddFooters(pdf);

      // SEGUN METODO DESCARGAR O ENVIAR POR CORREO
      if (metodo === "supervisor") {
        pdf.save(`Usuario_${formUser.username}.pdf`);
      } else {
        dispatch(sendPerfilClient(pdf.output('datauristring').split(',')[1], formUser.email.trim()));
      }
    } catch (error) {
      dispatch(generalOpenModalError('Ocurrió un error al momento de generar el pdf'))
    }
  }


// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************
export const sendPerfilClient = 
  (pdfBase64: string, email: string) => async (dispatch: Dispatch<any>, getState: () => State) => {
    return await http
    .post(ENDPOINTS.SEND_PERFIL_EMAIL, {email, document: pdfBase64})
    .then(async (res: any) => {
      return true;
    })
    .catch(async (err) => {
      let message = 'Error al enviarle el perfil al cliente'
      await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      return false
    })
    .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_cu_Creacion =
  () => async (dispatch: Dispatch<any>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))

    // ================================================================================
    // Validación de Email
    const formUser = getState().gestionUsuario.creacionUsuario.formUser

    // ================================================================================
    // Creación de Usuario
    const body = {
      username: formUser.username.trim(),
      passwd: formUser.passwd,
      birth_date: formUser.birth_date,
      first_name: formUser.first_name.trim(),
      second_name: formUser.second_name.trim(),
      third_name: formUser.third_name.trim(),
      last_name: formUser.last_name.trim(),
      last_name2: formUser.last_name2.trim(),
      last_name_married: formUser.last_name_married.trim(),
      nit: formUser.nit.trim(),
      id_number: formUser.id_number.trim(),
      codigo_empresa: localStorage.getItem(KEYS.CODIGO_EMPRESA),
      email: formUser.email.trim(),
      phone_number: formUser.phone_number.trim(),
      location: formUser.location.trim(),
      role_access_user: resolverRolID(formUser.role_access_user || ROL_POR_OMISION),
      description: 'Supervisor creo este usuario',
    }

    await http
      .post(ENDPOINTS.CREAR_USUARIO_CREACION, body)
      .then(async (res: any) => {
        if (res?.data) await dispatch(gu_cu_SetIdUsuarioCreado(res.data))
        await dispatch(gu_cu_ShowModalConfirmacion(true))
      })
      .catch(async (err) => {
        let message = 'Intente nuevamente crear el usuario'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_cu_EnviarCodigoEmail =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    dispatch(generalShowLoader(true))
    const formUser = getState().gestionUsuario.creacionUsuario.formUser
    const params = {username: formUser.username.trim()}
    await http
      .get(`${ENDPOINTS.CREAR_USUARIO_ENVIAR_EMAIL}?username=${params.username}`)
      .then(async (res) => {
        await dispatch(gu_cu_ShowModalConfirmacion(false))
        await dispatch(gu_cu_ShowModalVerificacion(true))
      })
      .catch(async (err) => {
        let message = 'Intente nuevamente reenviar el código'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_cu_VerificarCodigoEmail =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const {codeVerify, formUser} = getState().gestionUsuario.creacionUsuario

    const body = {
      username: formUser.username.trim(),
      code: codeVerify.code.trim(),
    }

    let message = 'Intente nuevamente enviar el código de verificación'
    await http
      .put(ENDPOINTS.CREAR_USUARIO_ENVIAR_EMAIL, body)
      .then(async (res: any) => {
        if (res.data) {
          dispatch(gu_cu_ChangePage(1))
          await dispatch(
            generalOpenModalInfo('Código de Verificación ha sido validado satisfactoriamente')
          )
          dispatch(gu_cu_ShowModalVerificacion(false))
          return
        }
        await dispatch(generalOpenModalError(res.message ?? message))
      })
      .catch(async (err: any) => {
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_cu_getSucusarles = () => async (dispatch: Dispatch<GestionUsuarioAction>) => {
  const userID = localStorage.getItem(KEYS.ID_CLIENT)

  let message = 'Existió un inconveniente al obtener las sucursales'
  await http
    .post(ENDPOINTS.GESTION_USUARIO_POST_SUCURSALES, {userID}, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      if (!res?.message) {
        dispatch(gu_cu_SetSucursales(res.body))
        return
      }
      await dispatch(generalOpenModalError(res.message ?? message))
    })
    .catch(async (err: any) => {
      await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
    })
}


export const gu_cu_setSucursalSeleccionada = (id_user: string, id_sucursal: string) => async (dispatch: Dispatch<any>) => {
  let message = 'Existió un inconveniente al guardar la sucursal por defecto del usuario'
  await http
    .put(ENDPOINTS.PERFIL_USUARIO_CHANGE_SUCURSAL, {id_user: parseInt(id_user), id_sucursal: parseInt(id_sucursal)}, {})
    .then(async (res: any) => {
      if (res.status === 200) return true
      else {
        await dispatch(generalOpenModalError(res.message ?? message))
        return false
      }
    })
    .catch(async (err: any) => {
      await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      return false
    })
}

export const gu_cu_ConfirmarCreaciónDeUsuario =
  () => async (dispatch: Dispatch<any>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const sucursales = getState().gestionUsuario.creacionUsuario.sucursalesAsignadas
    let error = false
    let responseUsuario: any = {}

    // ================================================================================
    // Creación de Usuario
    const formUser = getState().gestionUsuario.creacionUsuario.formUser

    const bodyCreacion = {
      username: formUser.username.trim(),
      passwd: null,
      birth_date: formUser.birth_date,
      first_name: formUser.first_name.trim(),
      second_name: formUser.second_name.trim(),
      third_name: formUser.third_name.trim(),
      last_name: formUser.last_name.trim(),
      last_name2: formUser.last_name2.trim(),
      last_name_married: formUser.last_name_married.trim(),
      type_id_number: formUser?.tipoDocumento?.trim(),
      id_number: formUser.id_number.trim(),
      codigo_empresa: localStorage.getItem(KEYS.CODIGO_EMPRESA),
      email: formUser.email.trim(),
      phone_number: formUser.phone_number.trim(),
      location: formUser.location.trim(),
      role_access_user: resolverRolID(formUser.role_access_user || ROL_POR_OMISION),
      description: 'Supervisor creo este usuario',
    }

    await http
      .post(ENDPOINTS.CREAR_USUARIO_CREACION, bodyCreacion)
      .then(async (res: any) => {
        if (res?.data) {
          await dispatch(gu_cu_SetIdUsuarioCreado(res.data))
          responseUsuario = res.data
          return
        }
        dispatch(generalOpenModalError(res?.data?.message ?? message))
        error = true
      })
      .catch(async (err) => {
        let message = 'Intente nuevamente crear el usuario'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
        error = true
      })

    // ! El usuario no se pudo crear
    if (error) {
      dispatch(generalShowLoader(false))
      return
    }

    const bodyAceptacion = {
      admin_id: String(localStorage.getItem(KEYS.ID_CLIENT)), // ID Supervisor
      user_id: responseUsuario.user_id, // ID Facturador
      state_req: true,
      description: 'Facturador aceptado por el supervisor',
      email: false
    }
    let message = 'Existió un inconveniente al aceptar el usuario'

    // ===============================================================================
    // Enviar correo
    const params = {username: formUser.username.trim()}
    http
      .get(`${ENDPOINTS.CREAR_USUARIO_ENVIAR_EMAIL}?username=${params.username}`)
      .then(async (res) => {})
      .catch(async (err) => {
        let message = 'Intente nuevamente reenviar el código'
        await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })

    // ================================================================================
    // Aceptación de Usuario
    http
      .put(ENDPOINTS.GESTION_USUARIO_PUT_ACEPTAR_USUARIO, bodyAceptacion, {})
      .then((res: any) => {
        if (res.status === 200) return
        dispatch(generalOpenModalError(res?.data?.message ?? message))
      })
      .catch((err: any) => {
        dispatch(generalOpenModalInfo(err?.response?.data?.message ?? message))
      })

    if (sucursales.length === 0) {
      dispatch(gu_cu_ShowModalCreado(true))
      dispatch(gu_cu_ShowModalConfirmar(false))
      dispatch(generalShowLoader(false))
      return
    }

    // ================================================================================
    // Asignación de Sucursales
    const bodyAsignacion = {
      usuario_idusuario: responseUsuario.user_id,
      usuarioSucursal: sucursales.map((idSucursal) => ({sucursal_idsucursal: idSucursal})),
    }
    let msn = 'El cliente fue creado exitosamente. Pero,'
    message = 'Existió un inconveniente al asignar las sucursales'

    await http
      .post(ENDPOINTS.GESTION_USUARIO_POST_ASIGNAR_SUCURSALES, bodyAsignacion, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (!res.message) {
          dispatch(gu_cu_ShowModalCreado(true))
          dispatch(gu_cu_ShowModalConfirmar(false))
          // Enviar correo del perfil
          dispatch(generatePDFInfo("client"));
        } else await dispatch(generalOpenModalError(`${msn} ${res.message}`))
      })
      .catch(async (err: any) => {
        await dispatch(generalOpenModalError(`${msn} ${err?.response?.data?.message ?? message}`, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))

    // ================================================================================
    // Seleccionar sucursal por defecto
    dispatch(gu_cu_setSucursalSeleccionada(responseUsuario.user_id, sucursales[0]))
  }

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************
export const gu_cu_validacionesCreacionUsuarioOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {formUser} = getState().gestionUsuario.creacionUsuario
    let {name, value} = e.target
    let message = validacionesOnBlurFacturador(name, value, formUser.nombreTipoDocumento)
    dispatch(gu_cu_creacionUsuarioFormAddError({[name]: message}))
  }

export const gu_cu_validacionesCreacionUsuarioSiguiente =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {formUser, formError} = getState().gestionUsuario.creacionUsuario
    let errors = {...formError}

    errors.first_name = validacionesOnBlurFacturador('first_name', formUser.first_name)
    errors.second_name = validacionesOnBlurFacturador('second_name', formUser.second_name)
    errors.third_name = validacionesOnBlurFacturador('third_name', formUser.third_name)
    errors.last_name = validacionesOnBlurFacturador('last_name', formUser.last_name)
    errors.last_name2 = validacionesOnBlurFacturador('last_name2', formUser.last_name2)
    errors.last_name_married = validacionesOnBlurFacturador(
      'last_name_married',
      formUser.last_name_married
    )
    errors.phone_number = validacionesOnBlurFacturador('phone_number', formUser.phone_number)
    errors.birth_date = validacionesOnBlurFacturador('birth_date', formUser.birth_date)
    errors.tipoDocumento = validacionesOnBlurFacturador(
      'tipoDocumento',
      formUser.nombreTipoDocumento!
    )
    errors.id_number = validacionesOnBlurFacturador(
      'id_number',
      formUser.id_number,
      errors.tipoDocumento ? DICCIONARIO.NUMERO_IDENTIFICACION : formUser.nombreTipoDocumento
    )

    dispatch(gu_cu_creacionUsuarioFormAddError(errors))
    if (
      errors.passwd ||
      errors.passwd2 ||
      errors.birth_date ||
      errors.first_name ||
      errors.last_name ||
      errors.id_number ||
      errors.phone_number
    )
      return true
    return false
  }

export const gu_cu_validacionesCreacionUsuarioSiguiente2 =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {formUser, formError} = getState().gestionUsuario.creacionUsuario
    let errors = {...formError}
    errors.username = validacionesOnBlurFacturador('username', formUser.username)
    errors.email = validacionesOnBlurFacturador('email', formUser.email)
    errors.location = validacionesOnBlurFacturador('location', formUser.location)

    dispatch(gu_cu_creacionUsuarioFormAddError(errors))
    if (errors.username || errors.email) return true
    return false
  }

export const gu_cu_validacionesCodigoOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<GestionUsuarioAction>) => {
    let {name, value} = e.target
    let message = validacionesCodigoOnBlurFacturador(name, value)
    dispatch(gu_cu_creacionUsuarioFormAddErrorCode({error: message}))
  }

export const gu_cu_validacionesCodigoEnviar =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let {code, error} = getState().gestionUsuario.creacionUsuario.codeVerify
    error = validacionesCodigoOnBlurFacturador('code', code)
    dispatch(gu_cu_creacionUsuarioFormAddErrorCode({error}))
    if (error) return true
    return false
  }
